<template>
  <CertList />
</template>

<script>
import CertList from '@/components/cert/CertList.vue';

export default {
  components: {
    CertList
  },
}
</script>

<style lang="scss" scoped></style>